import type { CompaniesMiniEntity } from "@/features/companies/domain/entities/CompaniesMiniEntity"
import type { MealTiersMiniEntity } from "@/features/mealTiers/domain/entities/MealTiersMiniEntity"

export class MealCategoryFilterEntity {
    id?: number
    enabled?: boolean
    isTierFree?: boolean
    isCompanyFree?: boolean
    company?: CompaniesMiniEntity
    mealTier?: MealTiersMiniEntity
    name?: string
    searchWord?: string
    page?: number
    limit?: number
    sortField?: string
    sortDescending?: boolean
}